import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function App() {
  const backgroundImage = `${process.env.PUBLIC_URL}/images/281.jpg`;

  return (
    <div className="App">
      {/* Animated Background */}
      <div className="background">
        <div
          className="background-image"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
        <div className="noise"></div>
      </div>

      {/* Navigation */}
      <nav className="nav">
        <div className="nav-content">
          <Link to="/" className="logo">NZBEE</Link>
          <div className="nav-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="separator">•</span>
          <Link to="/terms">Terms of Service</Link>
          <span className="separator">•</span>
          <a href="mailto:contact@nzbee.net">Contact</a>
        </div>
        <p className="footer-disclaimer">
          NZBEE is not affiliated with any third-party search services or download clients.
        </p>
      </footer>
    </div>
  );
}

export default App;
